export default "__VITE_ASSET__BhBnIlDD__"